import React from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

import { spacing } from 'ui/theme/utils';
import device from 'ui/theme/device';

export const SidebarWidth = 300; // px

export const Sidebar = styled.div`
  display: flex;
  flex-direction: column;
  min-width: ${({ width = `${SidebarWidth}px` }) => width};
  height: 100%;
  background-color: ${({ theme }) => theme.colors.tertiary};
  ${(props) => spacing(props)}
  @media ${device.small} {
    position: absolute;
    z-index: 2;
  }
`;

export const SidebarMenu = ({ links = [] }) => {
  return (
    <Menu>
      {links.map(
        ({ label, hidden, ...rest }, index) =>
          !hidden && (
            <MenuLink key={index} {...rest}>
              {label}
            </MenuLink>
          )
      )}
    </Menu>
  );
};

const MenuLink = ({ children, to, disabled, ...rest }) => {
  return (
    <ListItem {...rest}>
      <StyledNavLink to={to} exact activeClassName="active" disabled={disabled}>
        {children}
      </StyledNavLink>
    </ListItem>
  );
};

const StyledNavLink = styled(NavLink)`
  position: relative;
  font-weight: ${({ fontWeight = 'normal' }) => fontWeight};
  font-size: 16px;
  letter-spacing: 0.04em;
  text-align: left;
  color: #fff;
  width: 100%;
  padding-top: ${({ theme }) => theme.spacing.xs};
  padding-bottom: ${({ theme }) => theme.spacing.xs};
  padding-left: ${({ theme }) => theme.spacing.l};
  &.active {
    background-color: rgba(0, 0, 0, 0.11);
    font-weight: 500;
    &:before {
      content: '';
      display: block;
      position: absolute;
      left: 0;
      top: 0;
      height: 100%;
      width: 5px;
      //border-radius: 0 5px 5px 0;
      background-color: ${({ theme }) => theme.colors.primary};
    }
  }
  ${({ disabled }) =>
    disabled &&
    `
    pointer-events: none;
    opacity: 0.5;
  `}
`;

const Menu = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  width: 100%;
`;

const ListItem = styled.li`
  display: flex;
  margin-top: ${({ theme }) => theme.spacing.xxs};
`;
